export const idlFactory = ({ IDL }) => {
  const Error = IDL.Variant({
    'ProfileAlreadyHasRelay' : IDL.Null,
    'ProfileNotFound' : IDL.Null,
    'UnableToCreateRelay' : IDL.Null,
    'NotAuthenticated' : IDL.Null,
    'UnableToCreate' : IDL.Null,
  });
  const Result_1 = IDL.Variant({ 'ok' : IDL.Null, 'err' : Error });
  const NostrProfile = IDL.Record({
    'pk' : IDL.Text,
    'about' : IDL.Text,
    'username' : IDL.Text,
    'avatar_url' : IDL.Text,
    'encrypted_sk' : IDL.Text,
  });
  const NostricRelay = IDL.Record({
    'canister_id' : IDL.Text,
    'gateway_url' : IDL.Text,
  });
  const FollowedRelays = IDL.Record({
    'nostr' : IDL.Vec(IDL.Text),
    'nostric' : IDL.Vec(NostricRelay),
  });
  const Profile = IDL.Record({
    'followed_relays' : FollowedRelays,
    'private_relay' : NostricRelay,
    'is_pro' : IDL.Bool,
    'nostr_profile' : NostrProfile,
  });
  const Result = IDL.Variant({ 'ok' : Profile, 'err' : Error });
  const Result_2 = IDL.Variant({ 'ok' : NostricRelay, 'err' : Error });
  const anon_class_15_1 = IDL.Service({
    'addNostrRelay' : IDL.Func([IDL.Text], [Result_1], []),
    'addNostricRelay' : IDL.Func([IDL.Text, IDL.Text], [Result_1], []),
    'addProfile' : IDL.Func([NostrProfile], [Result], []),
    'app_vetkd_public_key' : IDL.Func(
        [IDL.Vec(IDL.Vec(IDL.Nat8))],
        [IDL.Text],
        [],
      ),
    'deleteProfile' : IDL.Func([], [Result_1], []),
    'encrypted_symmetric_key_for_caller' : IDL.Func(
        [IDL.Vec(IDL.Nat8)],
        [IDL.Text],
        [],
      ),
    'getBalance' : IDL.Func([], [IDL.Nat], []),
    'getDepositAddress' : IDL.Func([], [IDL.Text], []),
    'getProfile' : IDL.Func([], [Result], ['query']),
    'getSubaccountForCaller' : IDL.Func([], [IDL.Vec(IDL.Nat8)], []),
    'getSubaccountForPrincipal' : IDL.Func([IDL.Text], [IDL.Vec(IDL.Nat8)], []),
    'handleTransaction' : IDL.Func([IDL.Bool], [Result_2], []),
    'removeNostrRelay' : IDL.Func([IDL.Text], [Result_1], []),
    'removeNostricRelay' : IDL.Func([IDL.Text, IDL.Text], [Result_1], []),
    'symmetric_key_verification_key' : IDL.Func([], [IDL.Text], []),
    'updateProfile' : IDL.Func([NostrProfile], [Result], []),
    'whoAmI' : IDL.Func([], [IDL.Principal], []),
  });
  return anon_class_15_1;
};
export const init = ({ IDL }) => { return []; };
